<template>
  <div v-if="$site?.location" class="overflow-x-hidden">
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>

    <UNotifications />
    <UModals />

    <div id="teleports" class="bottom-0 fixed w-full z-20" />
  </div>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk;
  }
})

defineOgImageComponent('Preview')

useSiteHead()
</script>